import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'app-logged-out-dialog',
  templateUrl: './logged-out-dialog.component.html',
  styleUrls: ['./logged-out-dialog.component.scss']
})
export class LoggedOutDialogComponent  {

  constructor(private matDialogRef: MatDialogRef<LoggedOutDialogComponent>, private translocoService: TranslocoService) {
  }
 
  close(){
    this.matDialogRef.close();
  }
}
